// extracted by mini-css-extract-plugin
export default {"CareItemContainer":"CareItemContainer_CareItemContainer__XKljl"};